import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import { AppState } from '@/app/shared/interfaces';
import { authReducer } from './auth/auth.reducer';

export const reducers: ActionReducerMap<AppState> = {
    auth: authReducer,
};

export const metaReducers: MetaReducer<AppState>[] = [];
